mutation SetZoomIsEnabled($input: SetZoomIsEnabledInput!) {
    setZoomIsEnabled(input: $input) {
        authUrl
        zoomIntegration {
            isEnabled
        }
    }
}
